export default __webpack_public_path__ + "static/media/teresa.3ffa09fa.jpg";